var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "item-bundle",
    {
      attrs: {
        "bundle-type": _vm.bundleType,
        "bundle-components": _vm.bundleComponents,
        "padding-classes": _vm.paddingClasses,
        "padding-inline-styles": _vm.paddingInlineStyles
      }
    },
    [
      _vm.isPreview
        ? _c("div", { staticClass: "widget-placeholder p-0" }, [
            _c("div", [
              _c("p", { staticClass: "title mb-0" }, [
                _vm._v(
                  _vm._s(
                    _vm.$translate("Ceres::Widget.itemBundlePlaceholderTitle")
                  )
                )
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "description mt-3" }, [
                _vm._v(
                  _vm._s(
                    _vm.$translate(
                      "Ceres::Widget.itemBundlePlaceholderDescription"
                    )
                  )
                )
              ])
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }